import type { DataExplorerToolbarAction } from '../data-explorer/types';

export const isCollectionMenuAction = (action: { presentation?: unknown }) =>
  action.presentation === 'menu' || action.presentation === 'overflow';

/** Keep ordinary actions inline and reuse the shared accessible menu for explicit overflow. */
export function collectionToolbarActions(
  actions: Array<DataExplorerToolbarAction & { presentation?: unknown; destructive?: boolean }>,
  menuLabel: string,
): DataExplorerToolbarAction[] {
  const inline = actions.filter(action => !isCollectionMenuAction(action));
  const menu = actions.filter(isCollectionMenuAction);
  if (!menu.length) return inline;
  return [...inline, {
    id: 'collection-overflow',
    kind: 'menu',
    label: menuLabel,
    triggerLabel: menuLabel,
    items: menu.map(action => ({ ...action, separatorBefore: action.destructive === true })),
  }];
}
